import { localize, setLocale } from '@vee-validate/i18n';
import * as AllRules from '@vee-validate/rules';
import { configure, defineRule } from 'vee-validate';
import { CompanyDocument } from '~/utils/CompanyDocument';
import { PersonalDocument } from '~/utils/PersonalDocument';

const allRules: any = AllRules.all;

configure({
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: false,
  generateMessage: localize({
    'pt-Br': {
      messages: {
        required: 'campo obrigatório',
        email: 'email inválido',
        min: 'mínimo de {length} caracteres',
        max: 'máximo de {length} caracteres',
        password: 'senha inválida',
        confirmPassword: 'senhas não conferem',
        phoneNumber: 'número de telefone inválido',
        ssn: 'CPF inválido',
        taxId: 'CNPJ inválido',
        alpha: 'somente letras',
        alpha_num: 'somente letras e números',
        numeric: 'somente números',
        integer: 'somente números inteiros',
        alpha_space: 'somente letras e espaços',
        legalAge: 'Idade mínima é 18 anos',
      },
    },
    'en': {
      messages: {
        email: 'invalid email',
        alpha: 'only letters are allowed',
        required: 'required field',
        min: 'minimum length is {length}',
        max: 'maximum length is {length}',
        password: 'invalid password',
        confirmPassword: 'passwords don\'t match',
        phoneNumber: 'invalid phone number',
        ssn: 'invalid SSN',
        taxId: 'invalid TAX ID',
        alpha_spaces: 'only letters and spaces are allowed',
        alpha_num: 'only letters and numbers are allowed',
        numeric: 'only numbers are allowed',
        integer: 'only integers are allowed',
        zipCode: 'invalid zip code',
        legalAge: 'Minimum age is 18 years',
      },
    },
  } as any),
});

setLocale('pt-Br');

Object.keys(allRules).forEach((rule) => {
  defineRule(rule, allRules[rule]);
});

defineRule('ssn', (value: string) => PersonalDocument(value).isValid);
defineRule('taxId', (value: string) => CompanyDocument(value).isValid);
defineRule('phoneNumber', (value: string) =>
  /\d{10,11}$/.test(removeMasks(value)));
defineRule('legalAge', (value: '^/d{2}/d{2}/d{4}$') => LegalAge(value));
